import React from 'react';
import PropTypes from 'prop-types';
import './shipment-approve-mode.scss';
import ShipmentMode from '../shipment-mode/shipment-mode';

function ShipmentApproveMode({ value, mode }) {
  return (
    <div className={`shipment-approve-mode${value === '' ? ' no-value' : ''}`}>
      {value !== '' && <p className="value">{value}</p>}
      <ShipmentMode shipmentMode={mode} />
    </div>
  );
}

ShipmentApproveMode.propTypes = {
  value: PropTypes.string,
  mode: PropTypes.string,
};
ShipmentApproveMode.defaultProps = {
  value: '',
  mode: '',
};
export default ShipmentApproveMode;
